import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscDomainService } from 'src/app/_common/domain/base-misc-domain.service';
import { MediaTypes } from 'src/app/_common/services/files.service';
import { VbrJobMiscApiService } from '@apps/bckp/api/veeam/vbr/vbr-job-misc-api.service';

@Injectable({
    providedIn: 'root'
})
export class VbrJobMiscDomainService extends BaseMiscDomainService
{

    constructor (private jobMiscApiService: VbrJobMiscApiService)
    {
        super();
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.jobMiscApiService.export(qs, format);
    }
}
